import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/fuel-surcharge')({
  component: AdminFuelSurchargeLayoutRoute,
});

function AdminFuelSurchargeLayoutRoute() {
  return <Outlet />;
}
